import { h } from '@stencil/core';

export const defaultOptionTemplate = (item, highlight, term?) => {
  const itemValue = item;
  const showHighlight = highlight && term;
  // console.log('item in template', item);
  return [
    // @ts-ignore
    <div value={itemValue}>{showHighlight ? <span innerHTML={item.highlightedLabel}></span> : item.label}</div>,
    null
  ];
};

export const defaultLabelTemplate = item => {
  // const itemLabel = item.label ?? item.name ? item.name : item;
  const itemLabel = item.label ?? item;
  // todo we want to make sure that label is always defined
  // return [<span class="jui-select__selected-item">{itemLabel}</span>, null];
  return [<div class="jui-select__selected-item">{itemLabel}</div>, null];
};
